export enum HomeTestIds {
  GallerySection = 'gallery_sec',
  ItemsSection = 'items_sec',
  StoresSection = 'stores_sec',
  asset = 'asset_item',
  gallery = 'gallery_item',
}
